





















import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { ProductAccessoriesApi, ProductAccessory } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';

@Component({
	components: {
		RouterLinkButton,
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class AccessoriesList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'uniqueId', sortable: true },
			{ key: 'serialNumber', sortable: true },
			{ key: 'accessoryType', label: 'Accessory Type', sortable: true },
			{ key: 'entityType', label: 'Attached To Type', sortable: true },
			{ key: 'entityId', label: 'Attached To Id', sortable: true },
		],
		loading: false,
		search: '',
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [];

	private api: ProductAccessoriesApi = new ProductAccessoriesApi();

	public reload() {
		this.$root.$emit('bv::refresh::table', 'accessories-datatable');
	}

	public clickTable(item: ProductAccessory, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'accessories.view',
				params: { accessoryId: item.id },
			} as any);
			window.open(routeData.href);
		} else {
			this.$router.push({
				name: 'accessories.view',
				params: { accessoryId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];

		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				// filters.push({field: 'serialNumber', value: this.state.search});
				this.state.search = this.state.search.replaceAll(' ', '-'); // Allowing spaces to be typed instead of dashes
				filters.push({ field: 'custom', value: this.state.search });
			}
			const response = await this.api.getAccessories(
				ApiUtils.queryOptions(filters, ctx, { params: { include: '' } }),
			);
			data = response.data.data;
			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;
		}
		return data;
	}
}
